/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useContext, useState } from "react";
import { Button, Container } from "@material-ui/core";
import PageTitle from "../../../components/pageTitle/PageTitle";
import ThemeTable from "../../../components/Table/ThemeTable";
import { Columns } from "./suppliesManageTableColumns";
import {
  getSupplyOrderList,
  subscribeNotes,
  updateArchive,
  UpdateMsgFalse,
} from "../../../services/apiservices/supplies";
import { useNavigate } from "react-router";
import { datetimest, FormatedDates } from "../../../services/helpers";
import { getEmployeesListBasedOnId } from "../../../services/apiservices/employee";
import { getClientsListbasedonIds } from "../../../services/apiservices/client";
import AuthContext from "../../../hooks/authContext";
import { cn } from "../../../components/ui/utils";
import { Eye, MessageCircle, MoreHorizontal, Plus, Wrench } from "lucide-react";
import { useMediaQuery } from "@mui/material";
import {
  CommonConfirmationDialog,
  SuppplyDataDialog,
} from "../../../components/DialogComponent/SupplyDataDialog";
import { Badge } from "../../../components/ui/badge";
import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
} from "../../../components/ui/card";
import FilterOrders from "./FilterOrders";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "../../../components/ui/dropDown";
import ManageSuppliesRequestDetails from "./ManageSupplyRequestDetails/ManageSupplyRequestDetails";
import { useToast } from "../../../hooks/useToast";
import { trackEvent, CMS_EVENTS } from "../../../services/apiservices/analytics";

const SuppliesManage = (props) => {
  const history = useNavigate();
  const auth = useContext(AuthContext);
  const [allSupplies, setAllSupplies] = React.useState([]);
  const [filteredList, setFilteredList] = React.useState([]);
  const isMobile = useMediaQuery("(max-width:767px)");
  const isLandscape = useMediaQuery(
    "(min-width: 771px) and (max-width: 940px)"
  );
  const [order, setOrder] = useState(null);
  const [searchTerm, setsearchTerm] = React.useState("");
  const [openSupplyDialog, setOpenSupplyDialog] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [priorityFilter, setPriorityFilter] = useState("All");
  const [statusFilter, setStatusFilter] = useState("All");
  const [openData, setOpenData] = useState(null);
  const [supplies, setSupplies] = useState([]);
  const [notes, setNotes] = useState([]);
  const [isLoading, setIsLoading] = React.useState(false);
  const [dialogOpen, setDialogOpen] = React.useState(false);
  const companyId =
    auth?.userProfile?.role === "companyUser"
      ? auth?.userProfile?.id
      : auth?.userProfile?.companyId;
  const supplyId = auth?.supplyId;
  const { toast } = useToast();

  const checkRowSearch = (searchTerm, row) => {
    const term = searchTerm.toLowerCase();
    return (
      row.status?.toLowerCase().includes(term) ||
      row.clientName?.toLowerCase().includes(term) ||
      row.employeeName?.toLowerCase().includes(term)
    );
  };

  const checkFilteredList = () => {
    if (allSupplies && Array.isArray(allSupplies)) {
      const filteredSuppliesList = allSupplies?.filter((row) => {
        const matchesSearch =
          searchTerm !== "" ? checkRowSearch(searchTerm, row) : true;

        const matchPriority =
          priorityFilter === "All" ? true : row?.priority === priorityFilter;

        const matchesStatus =
          statusFilter === "All" ? true : row?.status === statusFilter;

        return matchesSearch && matchPriority && matchesStatus;
      });
      setFilteredList(filteredSuppliesList);
    }
  };

  useEffect(() => {
    checkFilteredList();
  }, [allSupplies, searchTerm, priorityFilter, statusFilter]);

  const processSuppliesList = async (supplyResponse, notes = []) => {
    const records =
      supplyResponse?.filter(
        (order) => order.status !== "Pending" && order.status !== "Rejected"
      ) || [];

    const filterRecords = records?.filter(
      (order) =>
        order.status !== "Delivered" || (order.msg === true && !order.archive)
    );

    if (!filterRecords?.length) {
      auth.resetHighPrioritySupply?.();
      setAllSupplies([]);
      return;
    }

    const clientIds = [...new Set(records.map((r) => r.clientId))];
    const empIds = [...new Set(records.map((r) => r.createdBy))];

    const [clintsData, employeeData] = await Promise.all([
      clientIds?.length > 0
        ? new Promise((resolve, reject) => {
          getClientsListbasedonIds(
            clientIds,
            (result) => {
              const clients = result.map((item) => ({
                value: item?.id,
                label: item?.clientName || "Unknown Client",
              }));
              resolve(clients);
            },
            (err) => reject(err)
          );
        })
        : Promise.resolve([]),

      empIds?.length > 0
        ? new Promise((resolve) => {
          getEmployeesListBasedOnId(empIds, (result) => {
            const employees =
              result?.map((item) => ({
                value: item?.userId,
                label: `${item?.firstName || ""} ${item?.lastName || ""
                  }`.trim(),
                status: item?.status,
              })) || [];
            resolve(employees);
          });
        })
        : Promise.resolve([]),
    ]);

    const newRows = records
      ?.map((ritem) => {
        const client = clintsData?.find((c) => c?.value === ritem?.clientId);
        const notesData = notes?.filter((item) => item?.orderId === ritem?.id)
        const employee = employeeData?.find(
          (e) => e?.value === ritem?.createdBy
        );

        const totalQuantity =
          ritem.supplyItems?.reduce(
            (sum, item) => sum + (item.qty || 0),
            0
          ) || 0;

        return {
          ...ritem,
          orderId: String(ritem.orderNumber).padStart(6, "0"),
          supplies: `(${totalQuantity})`,
          employeeName: employee?.label || "Unknown Employee",
          clientName: client?.label || "Unknown Client",
          orderStatus: ritem.status,
          employeeData,
          notesData: notesData
        };
      })
      ?.filter((item) => item.archive === false || !item.archive);
    const id = localStorage.getItem('supplyId');
    if (id) {
      const order = newRows?.find((item) => item?.id === id);
      setSelectedOrder(order);
    } else if (supplyId) {
      localStorage.setItem("supplyId", supplyId);
      const order = newRows?.find((item) => item?.id === supplyId);
      setSelectedOrder(order);
      setShowDetailsModal(true);
    }
    const sortedData = sortingFunction(newRows);
    await setAllSupplies(sortedData);
  };

  useEffect(() => {
    setIsLoading(true);

    let unsubscribeSupplies;
    let unsubscribeNotes;

    unsubscribeNotes = subscribeNotes(
      { companyId },
      (notesRes) => {
        setNotes(notesRes || []);
      },
      (err) => {
        console.error("subscribeNotes error:", err);
      }
    );

    unsubscribeSupplies = getSupplyOrderList(
      { companyId, statusNotIn: ["Pending", "Rejected"] },
      (supplyResponse) => {
        setSupplies(supplyResponse || []);
        setIsLoading(false);
      },
      (err) => {
        console.error("subscribeToSupplyOrderList error:", err);
        setIsLoading(false);
      }
    );

    return () => {
      if (typeof unsubscribeSupplies === "function") unsubscribeSupplies();
      if (typeof unsubscribeNotes === "function") unsubscribeNotes();
    };
  }, []);

  useEffect(() => {
    if (supplies?.length > 0 || notes?.length > 0) {
      processSuppliesList(supplies, notes);
    }
  }, [supplies, notes]);

  const sortingFunction = (data) => {
    const statusOrder = {
      Ordered: 1,
      Shipped: 2,
      "Cancel Item": 3,
    };

    const result = data?.sort((a, b) => {

      const statusA = statusOrder[a?.status] || 99;
      const statusB = statusOrder[b?.status] || 99;

      if (a.orderId > b.orderId) return -1;
      if (a.orderId < b.orderId) return 1;

      if (statusA !== statusB) return statusA - statusB;

      const dateA = FormatedDates(a?.dateOfRequest);
      const dateB = FormatedDates(b?.dateOfRequest);
      if (dateA !== dateB) return dateB - dateA;

      if (a?.priority !== b?.priority) return b?.priority - a?.priority;

      if (a.employeeName < b.employeeName) return -1;
      if (a.employeeName > b.employeeName) return 1;

      return 0;
    });

    return result;
  };

  const onHandelClickFunction = async (order) => {
    setSelectedOrder(order);
    const formData = {
      id: order?.id,
    };

    UpdateMsgFalse(formData,
      () => console.log("Message flag updated in background"),
      (err) => console.error("Failed to update message flag", err)
    );

    localStorage.setItem('supplyId', order?.id)
    setShowDetailsModal(true);
    auth?.setSupplyId();
    trackEvent(CMS_EVENTS.SUPPLY_REQUEST_VIEWED, {
      order_id: order?.id,
      order_number: order?.orderId,
      client_name: order?.clientName
    });
  };

  const redirectToDetails = (id) => {
    if (typeof id !== "undefined" && id !== "")
      history("/supplies/cleaning/manage/" + id);
  };
  const redirectToArchivedPage = () => {
    history("/supplies/cleaning/archives");
  };
  const redirectToNewRequestPage = () => {
    history("/supplies/cleaning/review");
  };

  const getPriorityBadgeVariant = (priority) => {
    switch (priority) {
      case "1":
        return "danger";
      case "2":
        return "warning";
      case "3":
        return "info";
      default:
        return "secondary";
    }
  };

  const getPriorityLabel = (priority) => {
    switch (priority) {
      case "1":
        return "High";
      case "2":
        return "Medium";
      case "3":
        return "Low";
      default:
        return "Unknown";
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case "Ordered":
        return "bg-blue-100 text-blue-800";
      case "Delivered":
        return "bg-green-100 text-green-800";
      case "Shipped":
        return "bg-purple-100 text-purple-800";
      case "In Process":
        return "bg-slate-100 text-slate-800";
      case "Back Ordered":
        return "bg-slate-100 text-slate-800";
      case "Cancel Item":
        return "bg-gray-100 text-gray-800";
      case "Archived":
        return "bg-gray-100 text-gray-800";
      default:
        return "bg-slate-100 text-slate-800";
    }
  };

  const getDeliveryStatusColor = (status) => {
    switch (status) {
      case "Full Delivery":
        return "bg-green-100 text-green-800";
      case "Partial Delivery":
        return "bg-blue-100 text-blue-800";
      case "Full Shipment":
        return "bg-purple-100 text-purple-800";
      case "Partial Shipment":
        return "bg-indigo-100 text-indigo-800";
      case "In Process":
        return "bg-slate-100 text-slate-800";
      case "Cancelled":
        return "bg-red-100 text-red-800";
      case "Back Ordered":
        return "bg-red-100 text-red-800";
      default:
        return "bg-slate-100 text-slate-800";
    }
  };

  const getDeliveryStatus = (supplyItems) => {
    if (!supplyItems || !Array.isArray(supplyItems)) {
      return "Invalid Supplies";
    }

    const statuses = supplyItems.map((item) => item.status);

    const hasDelivered = statuses.includes("Delivered");
    const hasShipped = statuses.includes("Shipped");
    const hasOrdered = statuses.includes("Ordered");
    const hasBackOrdered = statuses.includes("Back Ordered");
    const hasCancelItem = statuses.includes("Cancel Item");

    if (
      statuses.every((status) => status === "Delivered") ||
      (hasDelivered &&
        hasCancelItem &&
        !hasOrdered &&
        !hasBackOrdered &&
        !hasShipped)
    ) {
      return "Full Delivery";
    }
    if (statuses.every((status) => status === "Cancel Item")) {
      return "cancelled";
    }
    if (
      hasDelivered &&
      (hasShipped || hasOrdered || hasBackOrdered || hasCancelItem)
    ) {
      return "Partial Delivery";
    }
    if (
      statuses.every((status) => status === "Shipped") ||
      (hasShipped &&
        hasCancelItem &&
        !hasDelivered &&
        !hasOrdered &&
        !hasBackOrdered)
    ) {
      return "Full Shipment";
    }
    if (hasShipped && (hasOrdered || hasBackOrdered) && !hasDelivered) {
      return "Partial Shipment";
    }
    if (hasOrdered && hasCancelItem) {
      return "In Process";
    }
    if (statuses.every((status) => status === "Ordered")) {
      return "In Process";
    }
    if (statuses.every((status) => status === "Back Ordered")) {
      return "Back Ordered";
    }
    if (hasOrdered && hasBackOrdered) {
      return "In Process";
    }
    return "In Process";
  };

  const handleConfirmArchive = async () => {
    setDialogOpen(false);
    const formData = {
      archive: true,
      archiveAt: datetimest(),
    };
    await updateArchive(order?.id, formData);
    // await fetchSuppliesList();
    trackEvent(CMS_EVENTS.SUPPLY_REQUEST_UPDATED, {
      order_id: order?.id,
      order_number: order?.orderId,
      status: "Archived"
    });
    setOrder(null);
    toast?.({ title: "Success", description: "Order Archived Successfully" });
  };

  const handleArchiveTicketDialogClose = () => {
    setOrder(null);
    setDialogOpen(false);
  };

  const renderRowCell = (rcellItem, hcellItem, index, rowindex) => {
    const showFlag = rcellItem?.readUser ? !rcellItem?.readUser?.includes(auth?.userProfile?.id) : false;
    let boldclasss = showFlag ? "fw-bold" : "";
    switch (hcellItem.id) {
      case "orderId":
        return (
          <span
            className="d-flex flex-center"
            style={{ fontSize: "14px", fontWeight: "600" }}
          >
            {rcellItem?.orderId}
            {rcellItem?.notesData?.length > 0 ? <MessageCircle className={`h-3 w-3 ml-5 ${showFlag === true ? "text-black-500" : "text-gray-500"}`} /> : null}
          </span>
        );
      case "employeeName":
        const data = rcellItem?.employeeData?.find(
          (item) => item?.value === rcellItem?.createdBy
        );
        return (
          <p
            className={boldclasss}
            style={{ color: data?.status === false ? "#9fa6b3" : "" }}
          >
            {rcellItem.employeeName}
          </p>
        );
      case "supplies":
        return (
          <div
            onClick={() => onHandelClickFunction(rcellItem)}
            style={{
              border: "1px solid hsl(214.3, 31.8%, 91.4%)",
              padding: "5px",
              fontWeight: "600",
              borderRadius: "40px",
            }}
          >
            {rcellItem?.supplyItems?.reduce(
              (total, supply) => total + supply?.qty,
              0
            )}{" "}
            <span className="ml-10">Items</span>
          </div>
        );
      case "dateOfRequest":
        return (
          <p className={boldclasss}>
            {FormatedDates(rcellItem?.dateOfRequest)}
          </p>
        );
      case "deliverStatus":
        const deliverStatus = getDeliveryStatus(rcellItem?.supplyItems);
        return (
          <Badge
            className={cn("capitalize", getDeliveryStatusColor(deliverStatus))}
          >
            {deliverStatus}
          </Badge>
        );
      case "orderStatus":
        return (
          <Badge
            className={cn("capitalize", getStatusColor(rcellItem?.orderStatus))}
          >
            {rcellItem?.orderStatus}
          </Badge>
        );
      case "priority":
        return (
          <Badge variant={getPriorityBadgeVariant(rcellItem?.priority)}>
            {getPriorityLabel(rcellItem?.priority)}
          </Badge>
        );
      case "action":
        const isDelivered = rcellItem?.status === "Delivered" || rcellItem?.status === "Cancel Item";
        return (
          <>
            <Button onClick={() => onHandelClickFunction(rcellItem)}>
              <Eye className="h-4 w-4 dark:text-white" />
            </Button>
            <DropdownMenu>
              <DropdownMenuTrigger asChild onClick={(e) => e.stopPropagation()}>
                <Button size="sm" variant="ghost">
                  <MoreHorizontal className="h-4 w-4 dark:text-white" />
                </Button>
              </DropdownMenuTrigger>
              <DropdownMenuContent
                style={{ zIndex: "9999px" }} className="dark:bg-[#1A1F2C] dark:text-white bg-white"
              >
                <DropdownMenuItem
                  onClick={(e) => {
                    e.stopPropagation();
                    setOrder(rcellItem);
                    setDialogOpen(true);
                  }}
                  disabled={!isDelivered}
                >
                  Archive Order
                </DropdownMenuItem>
              </DropdownMenuContent>
            </DropdownMenu>
          </>
        );

      default:
        return <p className={boldclasss}>{rcellItem[hcellItem?.id]}</p>;
    }
  };


  const handleDialogSupplyOpen = async (data) => {
    setOpenSupplyDialog(true);
    setOpenData(data);
  };

  const handleDialogSupplyClose = async () => {
    setOpenSupplyDialog(false);
    setOpenData(null);
  };



  return (
    <>
      <Container>
        <PageTitle
          pageTitle="Manage Supplies"
          showBreadcrumb={[{ label: "Home", to: "/" }, { label: "Supplies" }]}
          BreadCrumbCurrentPageTitle={"Manage"}
          // showLastSeen={true}
          buttonTitle="Supplies Archive"
          // icons={<Plus className="h-4 w-4 mr-5" />}
          buttonClass={"d-flex flex-center"}
          buttonStyle={{
            color: "white",
            backgroundColor: "#16A34A",
            padding: "8px 16px",
            borderRadius: "5px",
          }}
          buttonClick={() => redirectToArchivedPage()}
        />
        <div className={isMobile ? "pv-20 ph-10" : "pv-24 ph-32"}>
          <div
            className={
              isMobile
                ? "d-flex flex-direction-column pv-15 ph-12"
                : "d-flex flex-space-between flex-center mv-20"
            }
          >
            <div>
              <div
                className="text-foreground"
                style={{
                  fontSize: "24px",
                  fontWeight: "700",
                }}
              >
                Supply Management
              </div>
              <div
                className="mv-10"
                style={{ fontSize: "16px", color: "#6B7280" }}
              >
                Track  and manage your team’s supply request
              </div>
            </div>
          </div>
          <div className={`sectionBox2 dark:bg-[#1A1F2C] shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)]`}>
            <FilterOrders
              setPriorityFilter={setPriorityFilter}
              setStatusFilter={setStatusFilter}
              searchTerm={searchTerm}
              setsearchTerm={setsearchTerm}
            />
            {!isMobile && !isLandscape && (
              <ThemeTable
                rows={filteredList}
                headCells={Columns}
                hidePagination={false}
                isLoading={isLoading}
                renderRowCell={renderRowCell}
                sorting={true}
              // selectedRows={selectedRows}
              />
            )}
            {(isMobile || isLandscape) && (
              <>
                {filteredList?.map((order, index) => {
                  return (
                    <Card
                      key={order?.id}
                      className="overflow-hidden w-100 mb-15 dark:bg-[#1A1F2C] shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)]"
                    >
                      <CardHeader className="pb-2 p-24 bg-slate-50 dark:bg-[#1A1F2C]">
                        <div className="flex justify-between items-center">
                          <div>
                            <h3 className="font-semibold text-lg d-flex flex-center">
                              Order #{order?.orderId}
                              {order?.notesData?.length > 0 ? <MessageCircle className={`h-3 w-3 ml-5 ${order?.msg === true ? "text-black-500" : "text-gray-500"}`} /> : null}
                            </h3>
                            <p className="text-muted-foreground text-sm">
                              {FormatedDates(order?.dateOfRequest)}
                            </p>
                          </div>
                          <Badge
                            variant={getPriorityBadgeVariant(order?.priority)}
                          >
                            {getPriorityLabel(order?.priority)}
                          </Badge>
                        </div>
                      </CardHeader>
                      <CardContent className="p-24">
                        <div className="space-y-4">
                          <div className="grid grid-cols-1 gap-3 pb-24 border-b">
                            <div>
                              <p
                                className="text-xs text-muted-foreground uppercase font-medium"
                                style={{ color: "#64748B" }}
                              >
                                Client
                              </p>
                              <p
                                className="font-medium mt-4 text-[#020817] dark:text-white"
                                style={{ fontSize: "16px" }}
                              >
                                {order?.clientName}
                              </p>
                            </div>
                            <div>
                              <p
                                className="text-xs text-muted-foreground uppercase font-medium"
                                style={{ color: "#64748B" }}
                              >
                                Employee
                              </p>
                              <p
                                className="font-medium mt-4 text-[#020817] dark:text-white"
                                style={{ fontSize: "16px" }}
                              >
                                {order?.employeeName}
                              </p>
                            </div>
                          </div>

                          <div className="pb-3 border-b">
                            <div className="flex justify-between mb-16">
                              <p
                                className="text-xs text-muted-foreground uppercase font-medium"
                                style={{ color: "#64748B" }}
                              >
                                Status
                              </p>
                              <Badge
                                className={cn(
                                  "capitalize",
                                  getStatusColor(order?.orderStatus)
                                )}
                              >
                                {order?.orderStatus}
                              </Badge>
                            </div>
                          </div>

                          <div>
                            <div className="flex justify-between items-center mb-16">
                              <p
                                className="text-xs text-muted-foreground uppercase font-medium"
                                style={{ color: "#64748B" }}
                              >
                                Items
                              </p>
                              <Badge
                                variant="outline"
                                className="cursor-pointer"
                                onClick={() => onHandelClickFunction(order)}
                              >
                                {order?.supplyItems?.reduce(
                                  (total, supply) => total + supply?.qty,
                                  0
                                )}{" "}
                                items
                              </Badge>
                            </div>
                          </div>
                        </div>
                      </CardContent>
                      <CardFooter className="flex flex-col border-t bg-slate-50 dark:bg-[#1A1F2C] p-20 gap-2">
                        {/* <div className="w-full text-sm text-muted-foreground">
                          <span className="text-xs font-medium">
                            Est. Delivery:
                          </span>{" "}
                          {format(order.estimatedDelivery, "MMM d, yyyy")}
                        </div> */}
                        <div className="w-full d-flex flex-justify-end gap-2">
                          {/* <Button size="sm" variant="outline" onClick={() => handleStatusChange(order)}>
                        <Truck className="h-3 w-3 mr-1" /> Update
                      </Button> */}
                          <Button
                            size="sm"
                            variant="contained"
                            color="primary"
                            onClick={() => onHandelClickFunction(order)}
                          >
                            <Eye className="h-3 w-3 mr-8" /> Details
                          </Button>
                        </div>
                      </CardFooter>
                    </Card>
                  );
                })}
              </>
            )}
          </div>
        </div>
      </Container>
      <SuppplyDataDialog
        open={openSupplyDialog}
        onClose={handleDialogSupplyClose}
        listData={openData}
      />

      <ManageSuppliesRequestDetails
        showDetailsModal={showDetailsModal}
        setShowDetailsModal={setShowDetailsModal}
        selectedOrder={selectedOrder}
      // fetchSuppliesList={fetchSuppliesList}
      />
      <CommonConfirmationDialog
        open={dialogOpen}
        onConfirm={handleConfirmArchive}
        onClose={handleArchiveTicketDialogClose}
        title={"Archive Order"}
        message={
          "Are you sure you want to archive this order? This action will move the order to the archive and cannot be undone."
        }
        buttonTitle={"Yes, archive order"}
      />
    </>
  );
};
export default SuppliesManage;
